import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import base_url from './api/Config';
import TopBar from './component/TopBar';
import authFetch from './api/authFetch';

const RepaymentList = () => {
  const [repayments, setRepayments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const loanId = params.get('loanId');
  const applicationId = params.get('applicationId');

  const fetchRepayments = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const url = loanId
        ? `${base_url}/api/repayment/listByLoanId?loanId=${loanId}`
        : `${base_url}/api/repayment/repaymentListByApplicationId?applicationId=${applicationId}`;
      const res = await authFetch(url);
      if (!res.ok) throw new Error('Failed to fetch repayment list');
      const data = await res.json();
      data.sort((a, b) => a.emiStatus !== b.emiStatus ? a.emiStatus - b.emiStatus : a.emiNumber - b.emiNumber);
      setRepayments(data);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setIsLoading(false);
    }
  }, [loanId, applicationId]);

  useEffect(() => { fetchRepayments(); }, [fetchRepayments]);

  const getStatusBadge = (status) => (
    status === 0
      ? <span className="status-badge badge-orange">Pending</span>
      : <span className="status-badge badge-green">Paid</span>
  );

  return (
    <div className="app-page">
      <TopBar title={`Repayments #${loanId || applicationId}`} backPath="/Home" />

      <div className="app-content">
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 60 }}>
            <Circles height={60} width={60} color="#1d2e77" />
          </div>
        ) : error ? (
          <div className="app-card" style={{ color: '#e53935', textAlign: 'center' }}>{error}</div>
        ) : repayments.length === 0 ? (
          <div className="app-card" style={{ textAlign: 'center', color: '#888', padding: 32 }}>
            <p style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Loan not yet approved</p>
            <p style={{ fontSize: 13 }}>Repayment details will appear here once the loan is approved.</p>
          </div>
        ) : (
          <>
            <div style={{
              background: '#fff8e1', border: '1px solid #ffcc02', borderRadius: 10,
              padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10,
            }}>
              <span style={{ fontSize: 18 }}>ℹ️</span>
              <span style={{ fontSize: 13, color: '#795548', fontWeight: 600 }}>
                Payments cannot be made through the app. Please visit the branch to make your payment.
              </span>
            </div>

            {repayments.map((item) => (
              <div key={item.id} className="list-card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <p style={{ fontSize: 16, fontWeight: 700, color: '#1d2e77', marginBottom: 4 }}>EMI #{item.emiNumber}</p>
                    <p style={{ fontSize: 13, color: '#666', marginBottom: 2 }}>Amount: <strong>₹{item.emiAmount}</strong></p>
                    <p style={{ fontSize: 13, color: '#666', marginBottom: 2 }}>Principal: <strong>₹{item.principal}</strong></p>
                    <p style={{ fontSize: 13, color: '#666', marginBottom: 0 }}>Interest: <strong>₹{item.interest}</strong></p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    {getStatusBadge(item.emiStatus)}
                    <p style={{ fontSize: 12, color: '#666', marginTop: 8 }}>Due: <strong>{item.dueDate}</strong></p>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default RepaymentList;
